/* eslint-disable */

export let mixed = {
  default: 'is invalid',
  required: 'is a required field',
  oneOf: 'must be one of the following values: ${values}',
  notOneOf: 'must not be one of the following values: ${values}',
  notType: 'is not a ${type}',
};

export let string = {
  length: 'must be exactly ${length} characters',
  min: 'must be at least ${min} characters',
  max: 'must be at most ${max} characters',
  matches: 'must match the following: "${regex}"',
  email: 'is invalid',
  url: 'must be a valid URL',
  trim: 'must be a trimmed string',
  lowercase: 'must be a lowercase string',
  uppercase: 'must be a upper case string',
};

export let number = {
  min: 'must be greater than or equal to ${min}',
  max: 'must be less than or equal to ${max}',
  lessThan: 'must be less than ${less}',
  moreThan: 'must be greater than ${more}',
  notEqual: 'must be not equal to ${notEqual}',
  positive: 'must be a positive number',
  negative: 'must be a negative number',
  integer: 'must be an integer',
};

export let date = {
  min: 'field must be later than ${min}',
  max: 'field must be at earlier than ${max}',
};

export let boolean = {};

export let object = {
  noUnknown: 'field cannot have keys not specified in the object shape',
};

export let array = {
  min: 'field must have at least ${min} items',
  max: 'field must have less than or equal to ${max} items',
};

// Custom methods defined by Neat
export const customMethods = {
  disallowSpaces: 'must not contain spaces',
  equalTo: 'does not match',
  hasDigits: 'should contain at least one digit',
  hasKeys: 'required',
  isSameOrBefore: 'entered cannot be in the future',
  isSameOrAfter: 'entered cannot be in the past',
  hasLetterChars: 'should contain at least 1 letter',
  hasSpecialChars: 'should contain at least 1 special character (e.g. !, @, #, $, %, etc.)',
  notEqualTo: 'cannot be equal to',
}

export default {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean,
};
